import axios from "axios"
import Keys from '@/constant/key'
import { ElMessage } from 'element-plus'

export interface beforeUploadOptionsI {
    minSize?: number, // 最小体积
    size?: number, // 最大体积
    width?: number | number[], // 宽
    height?: number | number[], // 高
    maxWidth?: number, // 最宽
    maxHeight?: number, // 最高
    ratio?: number, // 宽高比
}
// 上传参数类型
export interface uploadOptionsI {
    folderName?:    string  // 文件名称
}
// 上传返回数据类型
export interface resI {
    code:   any,
    data:   any,
    msg:    string
}
// 上传返回 data 类型
export interface resDataI {
    uid:    string,     // 唯一 ID
    name:   string,     // 文件名
    url:    string,     // 文件链接
    file_path?: string,  // 文件路径
}

export const beforeUpload = async (file, options:beforeUploadOptionsI) => {
    try {
        return new Promise((resolve, reject) => {
            const { minSize, size, width, height, maxWidth, maxHeight, ratio } = options
            if (minSize) {
                const fileSize = file.size
                if (fileSize / 1024 < minSize) {
                    ElMessage({ type: 'error', message: `图片不能小于 ${minSize}k ` })
                    reject(false)
                }
            }
            if (size) {
                const fileSize = file.size
                if (fileSize / 1024 > size) {
                    ElMessage({ type: 'error', message: `图片不能大于 ${size}k ` })
                    reject(false)
                }
            }
            if (width || height || maxWidth || maxHeight) {
                const result = checkWH(file, width, height, maxWidth, maxHeight)
                resolve(result)
            }
            if (ratio) {
                const result = checkRatio(file, ratio)
                resolve(result)
            }
            resolve(true)

        })
    } catch (error) {
        console.log(error)
    }
}

const checkWH = async (file, width: number | number[] = 0, height : number | number[] = 0, maxWidth : number = 0, maxHeight: number = 0) => {
    return await new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            let img:any = new Image()
            img.src = reader.result
            img.onload = () => {
                let widthList:number[] = [],
                    heightList:number[] = []
                const { width:imgWidth, height:imgHeight } = img

                if (width) {
                    typeof width === 'number' ? widthList.push(width) : widthList = width
                }
                if (height) {
                    typeof height === 'number' ? heightList.push(height) : heightList = height
                }

                if (widthList.length && !widthList.includes(imgWidth)) {
                    ElMessage({ type: 'error', message: `上传图片宽度必须为 ${widthList.join('/')}px` })
                    reject(false)
                }
                if (heightList.length && !heightList.includes(imgHeight)) {
                    ElMessage({ type: 'error', message: `上传图片高度必须为 ${heightList.join('/')}px` })
                    reject(false)
                }
                if (maxWidth && imgWidth > maxWidth) {
                    ElMessage({ type: 'error', message: `上传图片宽度必须小于 ${maxWidth}px` })
                    reject(false)
                }
                if (maxHeight && imgHeight > maxHeight) {
                    ElMessage({ type: 'error', message: `上传图片高度必须小于 ${maxHeight}px` })
                    reject(false)
                }
                
                resolve(true)
            }
        }
    })
}

const checkRatio = async (file, ratio: number) => {
    return await new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            let img:any = new Image()
            img.src = reader.result
            img.onload = () => {
                const { width, height } = img

                if (width / height != ratio) {
                    ElMessage({ type: 'error', message: `上传图片宽高比必须为${ratio}` })
                    reject(false)
                }
                
                resolve(true)
            }
        }
    })
}

// 图片上传
export const upload = async (file, options:uploadOptionsI = {}) => {
    let formData = new FormData()
    formData.append('file', file)
    let url = Keys.uploadUrl + (options.folderName || 'others') + '&uid=' + file.uid
    try {
        return await new Promise((resolve, reject) => {
            axios.post(url, formData).then(res => {
                const { status, data } = res
                if (status === 200) {
                    resolve(data)
                }
            })
        })
    } catch (error) {
        console.log(error)
    }
}

export const fileUpload = async (file, options:uploadOptionsI = {}) => {
    let formData = new FormData()
    formData.append('file', file)
    let url = Keys.pdfUploadUrl + '?uid=' + file.uid
    try {
        return await new Promise((resolve, reject) => {
            axios.post(url, formData).then(res => {
                const { status, data } = res
                if (status === 200) {
                    resolve(data)
                }
            })
        })
    } catch (error) {
        console.log(error)
    }
}

// 发票上传
export const invoiceUpload = async (file, options:uploadOptionsI = {}) => {
    let formData = new FormData()
    formData.append('file', file)
    let url = Keys.invoiceUploadUrl + '?uid=' + file.uid
    try {
        return await new Promise((resolve, reject) => {
            axios.post(url, formData).then(res => {
                const { status, data } = res
                if (status === 200) {
                    resolve(data)
                }
            })
        })
    } catch (error) {
        console.log(error)
    }
}

// 银行回单上传
export const bankUpload = async (file, options:uploadOptionsI = {}) => {
    let formData = new FormData()
    formData.append('file', file)
    let url = Keys.bankUploadUrl + '?uid=' + file.uid
    try {
        return await new Promise((resolve, reject) => {
            axios.post(url, formData).then(res => {
                const { status, data } = res
                if (status === 200) {
                    resolve(data)
                }
            })
        })
    } catch (error) {
        console.log(error)
    }
}

// export default upload
